export default __webpack_public_path__ + "static/media/Gijs-de-Rooij.08ba51f0.jpeg";